import React from 'react';
import { View, Text } from 'react-native';
import { OptionButton } from "@shared/components/md-design-system/Button/OptionButton";
import type { IMenuSection } from '../hooks/useSettingsMenu';

interface MenuSectionRendererProps {
  sections: IMenuSection[];
}

export const MenuSectionRenderer: React.FC<MenuSectionRendererProps> = ({ sections }) => {
  const renderMenuSection = (section: IMenuSection, index: number) => {
    const visibleItems = section.items.filter(item => item.condition !== false);

    if (visibleItems.length === 0) return null;

    return (
      <View key={index} className="">
        {section.title && (
          <Text className="text-xl font-medium mt-10 px-3">
            {section.title}
          </Text>
        )}
        <View>
          {visibleItems.map((item, itemIndex) => (
            <OptionButton
              key={itemIndex}
              icon={item.icon}
              title={item.title}
              onPress={item.onPress}
              showArrow={item.showArrow}
              className={item.className}
              isLoading={item.isLoading}
              optionColor={item.optionColor}
            />
          ))}
        </View>
      </View>
    );
  };

  return <>{sections.map(renderMenuSection)}</>;
};
